import React, { Fragment } from 'react'

const CountrycodeSegment = () => {
    return (
        <Fragment>
            <option value="+1"> +1</option>
            <option value="+92"> +92</option>
            <option value="+93"> +93</option>
            <option value="+355"> +355</option>
            <option value="+213"> +213</option>
            <option value="+376"> +376</option>
            <option value="+244"> +244</option>
            <option value="+54"> +54</option>
            <option value="+374"> +374</option>
            <option value="+61"> +61</option>
            <option value="+43"> +43</option>
            <option value="+994"> +994</option>

            <option value="+973"> +973</option>
            <option value="+880"> +880</option>
            <option value="+32"> +32</option>
            <option value="+229"> +229</option>
            <option value="+975"> +975</option>
            <option value="+591"> +591</option>
            <option value="+387"> +387</option>
            <option value="+267"> +267</option>
            <option value="+55"> +55</option>
            <option value="+359"> +359</option>

            <option value="+855"> +855</option>
            <option value="+237"> +237</option>
            <option value="+1"> +1</option>
            <option value="+56"> +56</option>
            <option value="+86"> +86</option>
            <option value="+57"> +57</option>
            <option value="+506">  +506</option>
            <option value="+385"> +385</option>
            <option value="+53"> +53</option>
            <option value="+357"> +357</option>
            <option value="+420">  +420</option>

            <option value="+45"> +45</option>
            <option value="+253"> +253</option>
            <option value="+20"> +20</option>
            <option value="+503">  +503</option>
            <option value="+372"> +372</option>
            <option value="+251"> +251</option>

            <option value="+358"> +358</option>
            <option value="+33"> +33</option>

            <option value="+995"> +995</option>
            <option value="+49"> +49</option>
            <option value="+233"> +233</option>
            <option value="+30"> +30</option>
            <option value="+502"> +502</option>

            <option value="+852">  +852</option>
            <option value="+36"> +36</option>

            <option value="+354"> +354</option>
            <option value="+91"> +91</option>
            <option value="+62"> +62</option>
            <option value="+98"> +98</option>
            <option value="+964"> +964</option>
            <option value="+353"> +353</option>
            <option value="+972"> +972</option>
            <option value="+39"> +39</option>

            <option value="+81"> +81</option>
            <option value="+962"> +962</option>

            <option value="+254"> +254</option>
            <option value="+965"> +965</option>

            <option value="+856"> +856</option>
            <option value="+371"> +371</option>
            <option value="+961"> +961</option>
            <option value="+370"> +370</option>
            <option value="+352"> +352</option>

            <option value="+60"> +60</option>
            <option value="+960"> +960</option>
            <option value="+52"> +52</option>
            <option value="+212"> +212</option>

            <option value="+95"> +95</option>

            <option value="+977"> +977</option>
            <option value="+31"> +31</option>
            <option value="+64">  +64</option>
            <option value="+234"> +234</option>
            <option value="+47"> +47</option>

            <option value="+968"> +968</option>

            <option value="+63"> +63</option>
            <option value="+48"> +48</option>
            <option value="+351"> +351</option>

            <option value="+974"> +974</option>

            <option value="+40"> +40</option>
            <option value="+7"> +7</option>

            <option value="+966"> +966</option>
            <option value="+65"> +65</option>
            <option value="+421"> +421</option>
            <option value="+27"> +27</option>
            <option value="+34"> +34</option>
            <option value="+94">  +94</option>
            <option value="+46"> +46</option>
            <option value="+41"> +41</option>

            <option value="+66"> +66</option>
            <option value="+216"> +216</option>
            <option value="+90"> +90</option>

            <option value="+971"> +971</option>
            <option value="+44"> +44</option>
            <option value="+1"> +1</option>

            <option value="+58"> +58</option>
            <option value="+84"> +84</option>

            <option value="+967"> +967</option>
            <option value="+263"> +263</option>

        </Fragment>
    )
    
}

export default CountrycodeSegment